<template>
  <div class="goods__details">
    <div class="goods__details__title">{{ goodsInfo.itemTitle }}</div>
    <div class="goods__details__price">
      <span class="goods__details__price__desc">¥{{ price(goodsInfo.itemSalePrice) }}</span>
      <span v-if="goodsInfo.packageUnit" class="goods__details__price__unit">{{ `元/${goodsInfo.packageUnit}` }}</span>
      <!-- <span v-if="isSpecial" class="goods__details__price__hint">
        <span v-if="goodsInfo.maxBuyCount >= 0">特价商品限购{{goodsInfo.maxBuyCount}}盒，超出以原价购买</span>
        <span v-else>特价商品不限购</span>
      </span> -->
      <span v-if="isO2OMemberItem" class="old-price">原价¥{{ price(goodsInfo.itemBaseSalePrice) }}</span>
      <span class="o2o-label" v-if="isO2OMemberItem">
        <img class="o2o-img" :src="require('@/assets/img/o2o.svg')" />
      </span>
    </div>
    <div class="goods__details__tags">
      <span class="goods__details__tags__item" v-if="isSpecial && !goodsInfo.havingAvailableCoupon">
        特殊说明：特价商品，不可用券
      </span>
    </div>
    <div v-if="showJoinO2OMemberBtn" class="o2o-join-member" @click="hanldeJoinMember">
      <img :src="require('@/assets/img/o2o-logo.svg')" class="o2o-logo" alt="">
      <span class="o2o-text">
        开通快药会员可享特价
      </span>
      <span class="o2o-price">
        ￥{{ price(goodsInfo.estimatedMemberPrice)}}
      </span>
      <van-icon
        size="12"
        name="arrow"
        color="#fff"
      />
    </div>
    <div class="goods__details__promotion">
      <div class="goods__details__promotion__title">
        <div class="special__title">
          <template v-if="goodsInfo.minBuyCount">
            <span class="tag">{{ goodsInfo.minBuyCount }}{{ goodsInfo.packageUnit }}</span>
            <span class="text">起购</span>
          </template>
        </div>
      </div>
      <div class="goods__details__promotion__content">
        <div class="special__content">
          <template v-if="goodsInfo.maxBuyCount && goodsInfo.maxBuyCount != '-1'">
            <span class="text">限购</span>
            <span class="tag">{{ goodsInfo.maxBuyCount }}{{ goodsInfo.packageUnit }}</span>
          </template>
        </div>
      </div>
    </div>
    <div class="goods__details__desc">
      <div class="item">批准文号：{{ goodsInfo.approval || '-' }}</div>
      <div class="item">规格： {{ goodsInfo.spec || '-' }}</div>
      <div class="item">生产日期：{{ goodsInfo.productDate || '-' }}</div>
      <div class="item">有效期至：{{ goodsInfo.expirationDate || '-' }}</div>
      <div class="item">包装： {{ goodsInfo.packageUnit || '-' }}</div>
      <div class="item">件包装： {{ goodsInfo.wholePackageNum || '-' }}</div>
      <div class="item">生产厂家：{{ goodsInfo.productFactoryName || '-' }}</div>
    </div>
    <div class="goods__details__number">
      数量：
      <el-input-number
        :step="buyMultiple"
        :disabled="disabled"
        v-model="num"
        :min="inputMin"
        :max="inputMax"
        size="small"
        @change="onStepperChange"
      ></el-input-number>
      <span v-if="disabled" class="stock">可购买数量小于起订量</span>
      <span v-else>
        <span v-if="this.stockNumber > 300" class="inStock">有货</span>
        <span v-else-if="stockNumber > 0" class="inStock">{{stockNumber}}</span>
<!--        <span v-else class="inStock">售罄</span>-->
      </span>
    </div>
    <div class="goods__details__money">
      单品合计：
      <span class="price">¥{{ price(totalPrice) }}</span>
    </div>
    <div class="goods__details__button">
      <!-- 商品状态： 1-下架, 2-售罄 -->
      <div v-if="goodsInfo.itemStatus == 1" class="vertical-align sellOut">
        <span class="middle">商品已下架</span>
      </div>
      <div v-else-if="goodsInfo.itemStatus == 2" class="vertical-align sellOut">
        <div @click.stop="remindRestock" class="vertical-align purchase purchase-max">
          <span class="middle">提醒商家补货</span>
        </div>
<!--        <span class="middle">商品已售罄</span>-->
      </div>
      <div v-else @click.stop="throttledAddCart" class="vertical-align purchase">
        <i style="margin-right: 4px" class="el-icon-shopping-cart-2 middle"></i>
        <span class="middle">加入购物车</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/services';
import { toDecimal2, priceFenToYuan } from '@/helpers/utils';
import { cloneDeep, debounce } from 'lodash';

export default {
  props: {
    goodsInfo: {
      type: Object,
      default: () => {}
    },
    quertInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    itemCode() {
      return this.$route.params.id;
    },
    showShopCoupon() {
      return this.goodsInfo?.couponInfo?.shopCouponInfos?.length;
    },
    showPlatformCoupon() {
      return this.goodsInfo?.couponInfo?.platformCouponInfos?.length;
    },
    isSpecial() {
      return this.goodsInfo?.activityType === 'SPECIAL_PRICE'
    },
    isO2OMemberItem() {
      return this.goodsInfo.customerContractFastMedicineServiceFlag && this.goodsInfo.configMemberPriceFlag;
    },
    showJoinO2OMemberBtn() {
      return (!this.goodsInfo.customerContractFastMedicineServiceFlag) && this.goodsInfo.configMemberPriceFlag;
    }
  },
  watch: {
    quertInfo() {
      this.handleAddBuy();
    }
  },
  data() {
    return {
      minBuyCount: 1, // 起购数
      maxBuyCount: 99999, // 最大限购数量
      stockNumber: 99999, // 库存
      buyMultiple: 1, // 购买倍数
      totalPrice: 0,
      num: 1,
      inputMax: 99999,
      inputMin: 1,
      disabled: false
    };
  },
  methods: {
    remindRestock() {
      api.goods
        .goodsStockOutAlert({
          itemCode: this.itemCode
        })
        .then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: '您已成功提醒商家补货'
            });
          }
        })
        .catch(({ error }) => {
          console.error(error)
        })
    },
    price(val) {
      return priceFenToYuan(val);
    },
    // 加购商品
    async addOrUpdateCart() {
      const params = {
        itemCode: this.itemCode,
        number: this.num,
        shopId: this.quertInfo.shopId,
        callAddCartScene: 1
      };
      if (this.quertInfo.cartId) {
        params.cartId = this.quertInfo.cartId;
      }
      api.cart
        .addOrUpdateCart(params, { handleError: true })
        .then(res => {
          if (res) {
            this.$message({
              type: 'success',
              message: `加购成功 ${res.resultMsg || ''}`
            });
            this.$emit('update-goodsInfo');
          }
        })
        .catch(({ error }) => {
          if (error.code === 'SHARE_ORDER-CART-SHOP_ITEM_OVER_MAX_LIMIT') {
            this.$confirm('购物车满啦，删掉一些试试', '提示', {
              confirmButtonText: '去清理购物车',
              cancelButtonClass: 'custom_confirm_button',
              confirmButtonClass: 'custom_confirm_button',
              cancelButtonText: '取消',
              alignFooter: 'right',
              type: 'warning'
            }).then(() => {
              this.$router.push('/cart');
            });
          } else if (error.code === 'SHARE_ORDER-CART-OVER_MAX_LIMIT') {
            this.$confirm('购物车满啦，删掉一些试试', '提示', {
              confirmButtonText: '去清理购物车',
              cancelButtonText: '取消',
              cancelButtonClass: 'custom_confirm_button',
              confirmButtonClass: 'custom_confirm_button',
              alignFooter: 'right',
              type: 'warning'
            }).then(() => {
              this.$router.push('/cart');
            });
          } else if (error.code === 'SHARE_ORDER-CART-ITEM_OVER_MAX_LIMIT') {
            this.$message({
              type: 'warning',
              message: '可购买的商品数量已达上限'
            });
          } else {
            this.$message(error.message || '请求错误');
          }
        });
    },
    handleAddBuy() {
      this.minBuyCount = this.quertInfo.minBuyCount;
      // maxBuyCount=-1 表示不存在最大值 大于0的情况下 取2库存和最大值的较小值
      this.maxBuyCount =
        this.quertInfo.maxBuyCount >= 0
          ? Math.min(this.quertInfo.maxBuyCount, this.quertInfo.stockNumber)
          : this.quertInfo.stockNumber;
      this.stockNumber = this.quertInfo.stockNumber;
      this.buyMultiple = this.quertInfo.buyMultiple;
      let number = this.quertInfo.numInCart || this.quertInfo.minBuyCount;
      if (number < this.quertInfo.buyMultiple) number = this.quertInfo.buyMultiple;

      if (number % this.buyMultiple !== 0) {
        if (number === this.minBuyCount) {
          const down = Math.ceil(number / this.buyMultiple) * this.buyMultiple;
          number = down;
        } else {
          const up = Math.ceil(number / this.buyMultiple) * this.buyMultiple;
          const down = Math.floor(number / this.buyMultiple) * this.buyMultiple;
          if (up <= this.maxBuyCount) {
            number = up;
          } else {
            number = down;
          }
        }
      }

      this.num = number;

      if (
        this.quertInfo.stockNumber < this.quertInfo.minBuyCount || // 库存 小于 最小起订量
        this.quertInfo.stockNumber === 0 || // 库存为0
        this.quertInfo.stockNumber < this.quertInfo.buyMultiple || // 库存 小于 倍数
        (this.quertInfo.maxBuyCount > 0 && this.quertInfo.maxBuyCount < this.quertInfo.buyMultiple) || // 限购 小于 倍数
        (this.quertInfo.maxBuyCount > 0 && this.quertInfo.minBuyCount > this.quertInfo.maxBuyCount) // 最小起订量 大于 限购数
      ) {
        this.$message.warning('可购买数量小于起订量');
        this.disabled = true;
      }
      this.getTotalPrice();
    },
    async getTotalPrice() {
      const res = await api.cart.calculatePriceInTime({
        itemCode: this.itemCode,
        number: this.num
      });
      this.totalPrice = res.totalPrice;
    },
    onStepperChange() {
      let copyNum = cloneDeep(Number(this.num));
      if (!this.num) {
        this.$message({
          type: 'warning',
          message: `最少${this.minBuyCount}${this.quertInfo.unit}起购`
        });
        copyNum = this.minBuyCount;
      }

      let maxBuyCount = this.maxBuyCount;
      if (maxBuyCount % this.buyMultiple !== 0) {
        const up = Math.floor(maxBuyCount / this.buyMultiple) * this.buyMultiple;
        maxBuyCount = up;
      }
      if (!this.isSpecial) {
        this.inputMax = maxBuyCount;
      } else {
        this.inputMax = 99999;
      }
      let minBuyCount = this.minBuyCount;
      if (minBuyCount % this.buyMultiple !== 0) {
        const up = Math.ceil(minBuyCount / this.buyMultiple) * this.buyMultiple;
        minBuyCount = up;
      }
      this.inputMin = minBuyCount;
      let maxReson = this.maxBuyCount < this.stockNumber ? '您最多可购买' : '库存剩余';

      if (copyNum < this.minBuyCount) {
        this.$message({
          type: 'warning',
          message: `最少${this.minBuyCount}${this.quertInfo.unit}起购`
        });
        copyNum = this.minBuyCount;
      } else if (copyNum > maxBuyCount) {
        if (!this.isSpecial) {
          this.$message({
            type: 'warning',
            message: `${maxReson}${maxBuyCount}${this.quertInfo.unit}`
          });
          copyNum = maxBuyCount;
        }
      }
      if (copyNum % this.buyMultiple !== 0) {
        if (copyNum === this.minBuyCount) {
          const down = Math.ceil(copyNum / this.buyMultiple) * this.buyMultiple;

          copyNum = down;
        } else {
          const up = Math.ceil(copyNum / this.buyMultiple) * this.buyMultiple;
          const down = Math.floor(copyNum / this.buyMultiple) * this.buyMultiple;
          if (up <= this.maxBuyCount) {
            copyNum = up;
          } else {
            copyNum = down;
          }
        }
      }
      setTimeout(() => {
        this.num = copyNum;
        this.calculatePrice();
      }, 100);
    },
    hanldeJoinMember() {
      location.href = 'https://itm.91jkys.com/project/internetDrugstore/#/o2o-outer'
    }
  },
  created() {
    this.calculatePrice = debounce(
      () => {
        this.getTotalPrice();
      },
      500,
      { leading: true, trailing: true }
    );
    this.throttledAddCart = debounce(
      () => {
        Telescope.trackEvent({
          trackId: 'zyb2bpc-event-spxqy-spxqydjjrgwcanB2B'
        })
        this.addOrUpdateCart();
      },
      500,
      { leading: true, trailing: false }
    );
  }
};
</script>

<style lang="scss" scoped>
.goods__details {
  width: 611px;
  &__title {
    font-size: 18px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  &__price {
    margin: 12px 0 0;
    &__desc {
      font-size: 18px;
      font-weight: 600;
      color: #fd5047;
      line-height: 1;
    }
    &__unit {
      margin-left: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
    }
    &__hint {
      font-size: 12px;
      color: #D48806;
      line-height: 12px;
      margin-left: 8px;
    }
  }
  &__tags {
    margin-top: 7px;
    &__item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: fit-content;
      padding: 0 12px;
      height: 24px;
      background: #FFF7E6;
      border-radius: 4px;
      font-size: 10px;
      color: #FF8200;
    }
  }
  &__promotion {
    display: flex;
    padding: 12px;
    background: #f5f5f5;
    margin-top: 12px;
    &__title {
      margin-right: 8px;
    }
    .special__title,
    .special__content {
      font-size: 0;
    }
    .special__title {
      margin-right: 8px;
    }
    .text {
      font-size: 12px;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
    }
    .tag {
      font-size: 12px;
      color: #fd8309;
      line-height: 20px;
    }
    .content {
      color: #262626;
      font-size: 12px;
      line-height: 20px;
    }
    .linkto {
      color: #1e8dff;
      cursor: pointer;
    }
    .coupon {
      display: inline-block;
      height: 20px;
      padding: 4px 8px;
      font-size: 12px;
      font-weight: 500;
      color: #ff3930;
      line-height: 12px;
      background: rgba(255, 57, 48, 0.1);
      border-radius: 2px;
      & + .coupon {
        margin-left: 4px;
      }
    }
    .bgb {
      background: #ffffff;
      border: 1px solid #c56767;
    }
    .tag__bg {
      display: inline-block;
      height: 16px;
      padding: 2px 4px;
      color: #ffffff;
      background: #ff8300;
      border-radius: 2px;
    }
    .mr8 {
      span + span {
        margin-left: 8px;
      }
    }
    &__title,
    &__content {
      div {
        height: 20px;
      }
      div + div {
        margin-top: 8px;
      }
    }
  }
  &__timer {
    height: 28px;
    margin-top: 16px;
    margin-bottom: 24px;
    background: linear-gradient(90deg, #fff8f2 0%, #ffefe1 100%);
    .align {
      vertical-align: middle;
    }
    .title {
      font-size: 12px;
      font-weight: 400;
      color: #262626;
    }
    .time {
      display: inline-block;
      height: 18px;
      padding: 2px 3px;
      font-size: 12px;
      line-height: 14px;
      color: #ffffff;
      background: #fc6c12;
      border-radius: 4px;
    }
    .free {
      float: right;
      height: 28px;
      margin-right: 12px;
      font-size: 12px;
      line-height: 28px;
      font-weight: 400;
      color: #595959;
    }
  }
  &__desc {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
    .item {
      width: 305px;
      margin-bottom: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #595959;
      line-height: 1;
    }
  }
  &__number {
    margin: 12px 0;
    font-size: 12px;
    font-weight: 400;
    color: #262626;
    .inStock {
      color: #595959;
      margin-left: 12px;
    }
    .stock {
      margin-left: 12px;
      font-size: 12px;
      font-weight: 400;
      color: #d96900;
      line-height: 12px;
    }
  }
  &__money {
    font-size: 12px;
    font-weight: 400;
    color: #262626;
    line-height: 1;
    .price {
      font-size: 12px;
      font-weight: 500;
      color: #fd5047;
    }
  }
  &__button {
    margin-top: 16px;
    margin-bottom: 32px;
    .button {
      width: 160px;
      height: 44px;
      color: #ffffff;
      background: #e55135;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      border: none;
      border-radius: 0;
    }
    .purchase,
    .sellOut {
      display: inline-block;
      width: 160px;
      height: 44px;
      background: #ee6916;
      font-size: 16px;
      font-weight: 400;
      color: #ffffff;
      line-height: 12px;
      text-align: center;
      cursor: pointer;
    }
    .purchase-max {
      width: 100%;
      margin-left: 0;
      background-color: #F1A31E;
    }
    .sellOut {
      background: #595959;
      color: #ffffff;
    }
  }

  ::v-deep .el-input-number {
    .el-input--small .el-input__inner {
      border-radius: 0;
    }
    .el-input__inner {
      border: 1px solid #e0e0e0;
    }
    .el-input-number__decrease,
    .el-input-number__increase {
      border-radius: 0;
    }
  }

  .old-price {
    font-size: 12px;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #8C8C8C;
    position: relative;
    top: 1px;
    margin-left: 4px;
  }

  .o2o-label {
    display: inline-flex;
    width: 60px;
    height: 14px;
    align-items: center;
    justify-content: center;
    border: 1px solid #FF8500;
    border-radius: 2px;
    margin-left: 8px;
    .o2o-img {
      width: 54px;
    }
  }

  .o2o-join-member {
    width: 100%;
    height: 36px;
    margin-top: 12px;
    background-image: url('~@/assets/img/o2o-to-join.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .o2o-logo {
      width: 14px;
      margin-right: 3px;
    }
    .o2o-text {
      font-size: 14px;
      color: #FFFFFF;
      line-height: 18px;
    }
    .o2o-price {
      font-size: 18px;
      color: #FFE53B;
      line-height: 18px;
    }
    .van-icon {
      position: relative;
      top: 2px;
      margin-left: 3px;
    }
  }
}
</style>
